<!--<template>
  <div class="about ml-3">
    <h3>Lumora v2.0.0</h3>
  </div>
</template>-->

<template>
  <v-container class="helpPage pl-4" fluid>
    <div v-if="!trainingPage && !patchNotesPage" class="panel-wrapper">
      <v-row dense>
        <v-col cols="6">
          <v-card class="square-panel hover-card" color="#C02090" @click="handleClick('chat')" hover ripple>
            <v-card-text class="text-center white--text content-fade">
              <v-icon size="36" class="mb-2">mdi-chat</v-icon>
              <div>Online Chat</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="square-panel hover-card" color="primary" @click="handleClick('help-desk')" hover ripple>
            <v-card-text class="text-center white--text content-fade">
              <v-icon size="36" class="mb-2">mdi-headset</v-icon>
              <div>Help Desk</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-card class="square-panel hover-card" color="primary" @click="handleClick('training')" hover ripple>
            <v-card-text class="text-center white--text content-fade">
              <v-icon size="36" class="mb-2">mdi-school</v-icon>
              <div>Training</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card class="square-panel hover-card" color="#C02090" @click="handleClick('patch-notes')" hover ripple>
            <v-card-text class="text-center white--text content-fade">
              <v-icon size="36" class="mb-2">mdi-clipboard-text</v-icon>
              <div>Patch Notes</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="trainingPage">
      <v-row>
        <v-col cols="3" class="mx-2">
          <v-list two-line>
            <v-subheader>Available Training Videos</v-subheader>
            <v-divider></v-divider>
            <v-list-item-group v-model="selectedVideoIndex" color="primary">
              <v-list-item
                v-for="(video, index) in videos"
                :key="index"
                @click="playVideo(video.src)"
                link
              >
                <v-list-item-content>
                  <v-list-item-title>{{ video.title }}</v-list-item-title>
                  <v-list-item-subtitle>{{ video.description }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <v-divider></v-divider>
          <v-btn
            class="mt-5"
            @click="
              trainingPage = false;
              currentVideo = null;
              selectedVideoIndex = null;
            "
            >Back to Help</v-btn
          >
        </v-col>

        <v-col cols="8" class="video-panel mx-2">
          <video
            v-if="currentVideo"
            ref="videoPlayer"
            :src="currentVideo"
            controls
            autoplay
            class="video-player"
          ></video>
          <div v-else class="video-placeholder">
            <v-icon class="mr-2" color="primary">mdi-information-outline</v-icon>
            Select a video to play
          </div>
        </v-col>
      </v-row>
    </div>

    <div v-else>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(release, index) in patchNotes" :key="index">
              <v-expansion-panel-header>
                <span>
                  <strong>{{ release.version }}</strong>
                  <span class="ml-3 grey--text">{{ release.date }}</span>
                  <v-chip v-if="index === 0" x-small color="primary" class="ml-3">Latest</v-chip>
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="patch-note-content" v-html="parseNotes(release.notes)"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-btn class="mt-5" @click="patchNotesPage = false">Back to Help</v-btn>
        </v-col>

      </v-row>
    </div>
  </v-container>
</template>

<script>
import { marked } from 'marked';

export default {
  name: 'Help',
  data: () => ({
    trainingPage: false,
    patchNotesPage: false,
    currentVideo: null,
    selectedVideoIndex: null,
    patchNotes: []
  }),
  async created() {
    const response = await fetch('/patchnotes.json');
    if (response.ok) {
      this.patchNotes = await response.json();
    }
  },
  computed: {
    videos(){
      return (this.$config && this.$config.tutorialVideos) || []
    }
  },
  methods: {
    handleClick(action) {
      switch (action) {
        case 'chat':
          window.open('https://vm.providesupport.com/1albtrwx4pvd10wc2kvkg2x4zn', '_blank');
          break;
        case 'help-desk':
          window.open('https://assl.freshdesk.com/', '_blank');
          break;
        case 'training':
          this.trainingPage = true;
          break;
        case 'patch-notes':
          this.patchNotesPage = true;
          break;
        default:
          break;
      }
    },

    parseNotes(notes) {
      const markdown = Array.isArray(notes) ? notes.join('\n\n') : notes;
      return marked.parse(markdown);
    },

    playVideo(src) {
      this.currentVideo = src;
      this.$nextTick(() => {
        const video = this.$refs.videoPlayer;
        if (video) {
          video.load();
          video.volume = 0.2;
          video.play();
        }
      });
    },
  },
};
</script>

<style scoped>
.helpPage {
  padding: 2rem 0;
  overflow-x: hidden;
}

.panel-wrapper {
  width: 450px;
}

.square-panel {
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px;
}

.video-player {
  max-width: 100%;
  max-height: 600px;
  height: auto;
  display: block;
}

.video-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.video-placeholder {
  width: 640px;
  height: 360px;
  background-color: #5e5c5c;
  color: #ffffff;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.hover-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.hover-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

/* Make icon and text dull by default */
.content-fade {
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

/* Brighten on hover */
.hover-card:hover .content-fade {
  opacity: 1;
}

.patch-note-content {
  line-height: 1.6;
}

.patch-note-content ::v-deep h1,
.patch-note-content ::v-deep h2,
.patch-note-content ::v-deep h3 {
  margin-top: 0.8rem;
  margin-bottom: 0.3rem;
  font-size: 1rem;
}

.patch-note-content ::v-deep ul {
  padding-left: 1.4rem;
  margin: 0.2rem 0;
}

.patch-note-content ::v-deep li {
  padding: 2px 0;
}

.patch-note-content ::v-deep p {
  margin: 0.3rem 0;
}
</style>
